<template>
  <v-container fluid>
    <v-row no-gutters>
        <v-col cols="12">
            <custom-data-table :tableName="tableName" :header="headers" :items="items" :loading="loading"
            :pagination="pagination" :visibleStore="visibleStore" @stored="storeBudget">
              <template v-slot:revision="{ item }">
                <v-chip color="success">
                  <v-avatar left><v-icon>mdi-checkbox-marked-circle</v-icon></v-avatar>{{ item.revision }}
                </v-chip>
              </template>
              <template v-slot:action="{ item }">
                <v-btn class="mr-2" depressed small @click.stop="infoBudget(item)" color="info">閲覧</v-btn>
                <v-btn v-show="item.take_over" class="mr-2" depressed small @click.stop="updatedBudget(item)" color="primary">引継作成</v-btn>
              </template>
            </custom-data-table>
        </v-col>
    </v-row>
  </v-container>
</template>


<script>
  import { useAppInsights } from '@/plugins/application-insights';
  import BudgetHistoryApi from "@/api/budget-history-api"
  import CustomDataTable from "@/components/custom_ui/CustomDataTable"

  export default {
    name: "WorkingBudget",
    components: {
      CustomDataTable
    },
    data: () => ({
      // 実行予算履歴テーブル
      loading: false,
      tableName: "実行予算書履歴",
      headers: [
        { text: "改訂No.", value: "revision" },
        { text: "更新者", value: "user_name" },
        { text: "更新日", value: "update_date" },
        { text: "アクション", value: "action" }
      ],
      items: [],
      pagination: {
          page: 1,
          pageCount: 0,
          itemsPerPage: 10,
      },
      constructionId: null,
      visibleStore: true
    }),
    created () {
      this.initialize();
    },
    methods: {
      isLoading() {
        this.loading = !this.loading;
        this.$emit("loading", this.loading);
      },
      initialize () {
        this.isLoading();
        this.budgetHistoryApi = new BudgetHistoryApi();
        this.constructionId = this.$route.params.id;
        const promise = this.budgetHistoryApi.info(this.constructionId);
        promise.then((response) => {
            this.items = response.data.body.budget_history_info;
            if (this.items.length > 0) {
              this.visibleStore = false;
              this.items[0].take_over = true;
            }
        }).catch(error => {
          useAppInsights().trackException({exception: error});
          if(error.response){
            this.$emit("error",error.response.data.message);
          }else{
            this.$emit("error","サーバーエラーが発生しました。");
          }
        }).finally(() => {
            this.isLoading();
        });
      },
      storeBudget() {
        this.$router.push({ name: 'WorkingBudgetStore', params: { id: this.constructionId } })
      },
      updatedBudget(item) {
        this.$router.push({ name: 'WorkingBudgetEdit', params: { id: this.constructionId, budget: item.id } })
      },
      infoBudget(item) {
        this.$router.push({ name: 'WorkingBudgetInfo', params: { id: this.constructionId, budget: item.id } })
      }
    }
  }
</script>
